export default "__VITE_ASSET__c05G7p13__";